import React, { FunctionComponent, ChangeEvent } from 'react';

import './form-input.scss';

interface IFormInputProps {
  label: string;
  value: string;
  type: string;
  required: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  showErrorMessage?: boolean;
  errorMessage?: string;
}

const FormInput: FunctionComponent<IFormInputProps> = ({
  label,
  showErrorMessage,
  errorMessage,
  ...props
}): JSX.Element => (
  <div className="form-input">
    <label htmlFor="access-code">{label}</label>
    <input {...props} id="access-code"/>
    {showErrorMessage && <p className="validation-error-message">{errorMessage}</p>}
  </div>
);

export default FormInput;
